"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionSelectorDropdown = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const storm_ui_1 = require("@amzn/storm-ui");
const Region_1 = require("../../../types/Region");
const TranslationProvider_1 = require("../TranslationProvider/TranslationProvider");
const regionUtils_1 = require("../../../utils/regionUtils");
const Constants_1 = require("../../../utils/Constants");
const helpers_1 = require("../../../test-utils/helpers");
function getSupportedEntityKeys(entityKeys) {
    // Checks if each supported EntityKeyType is present in entityKeys
    // Filters out bad regions accordingly
    return [
        entityKeys.ADSP_SHADOW_ENTITY_ACI_NA ? Region_1.Region.NA : null,
        entityKeys.ADSP_SHADOW_ENTITY_ACI_FE ? Region_1.Region.APAC : null,
        entityKeys.ADSP_SHADOW_ENTITY_ACI_EU ? Region_1.Region.EU : null,
    ].filter((val) => val !== null);
}
const RegionSelectorDropdown = ({ entityKeys, onChange, selectedValue }) => {
    const { translate } = (0, TranslationProvider_1.useTranslation)();
    // Only display regions that are supported and present in EntityKeys
    // Sort using custom ordering to preserve dropdown option order across all label translations
    const supportedRegionalKeys = getSupportedEntityKeys(entityKeys).sort(regionUtils_1.regionEnumOrdering);
    const chooseRegionTranslation = translate(Constants_1.chooseRegionTranslational);
    const onOverrideLabel = (dropdownValue, value) => {
        if (value) {
            return dropdownValue;
        }
        return chooseRegionTranslation;
    };
    return ((0, jsx_runtime_1.jsx)(storm_ui_1.Dropdown, { onChange: onChange, selectedValue: selectedValue, onOverrideLabel: onOverrideLabel, label: translate(Constants_1.regionTranslationLabel), fullWidth: true, "data-testid": Constants_1.regionSelectorDropdownTestId, children: supportedRegionalKeys.map((region) => {
            const regionLabel = translate((0, regionUtils_1.getRegionLabel)(region));
            return ((0, jsx_runtime_1.jsx)(storm_ui_1.DropdownItem, { value: region.toString(), "data-testid": (0, helpers_1.getRegionalDropdownItemId)(region), children: regionLabel }));
        }) }));
};
exports.RegionSelectorDropdown = RegionSelectorDropdown;
//# sourceMappingURL=RegionSelectorDropdown.js.map